import React, { useContext, useState } from "react";
import { project_name } from "../config/config";

const PGIModeContext = React.createContext();

export const usePGIMode = () => useContext(PGIModeContext);

export function ContextPGIMode({ children }) {
  const [profileNewImage, setProfileNewImage] = useState(
    localStorage.getItem("image") || ""
  );
  const [userName, setUserName] = useState(localStorage.getItem("name") || "");
  const [metaTitle, setMetaTitle] = useState(
    localStorage.getItem("metaTitle") || project_name
  );

  const collection = {
    profileNewImage,
    setProfileNewImage,
    userName,
    setUserName,
    metaTitle,
    setMetaTitle,
  };

  return (
    <PGIModeContext.Provider value={collection}>
      {children}
    </PGIModeContext.Provider>
  );
}
